import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import RadarContainer from '../../../components/Charts/Radar/RadarContainer';

import { Container } from './styles';

const surveysSpiritHoch3 = [55, 53, 56];
const Analytics: React.FC = () => {
  const { surveyId } = useParams();
  const [isSpiritHoch3, setIsSpiritHoch3] = useState(false);
  useEffect(() => {
    const isSpiritHochDrei = surveysSpiritHoch3.some(
      id => id.toString() === surveyId,
    );
    setIsSpiritHoch3(isSpiritHochDrei);
  }, [isSpiritHoch3, surveyId]);

  if (!surveyId) return <div>Survey ID não fornecido</div>;

  return (
    <Container>
      <h1>Analytics</h1>
      <RadarContainer
        pinkBackground={isSpiritHoch3}
        surveyId={+surveyId}
      ></RadarContainer>
    </Container>
  );
};

export default Analytics;
